module.exports = __webpack_public_path__ + "img/about_img1.ea0e8c04.png";